'use client';

import React from 'react';
import PickingHeader from './components/PickingHeader';
import PickingBoard from './components/PickingBoard';

export default function PickingPage() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <PickingHeader />
      <PickingBoard />
    </div>
  );
}
